import React from 'react';
import { GiftIcon } from 'lucide-react';
interface BonusCardProps {
  number: string;
  title: string;
  description: string;
  value: string;
}
export function BonusCard({
  number,
  title,
  description,
  value
}: BonusCardProps) {
  return <div className="bg-white border-4 border-[#27AE60] rounded-xl p-6 relative overflow-hidden shadow-md" data-id="element-253">
      <div className="absolute -right-4 -top-4 bg-[#27AE60] text-white font-bold py-1 px-8 rotate-45 transform origin-bottom-right shadow-sm" data-id="element-254">
        GRATIS
      </div>

      <div className="flex items-start gap-4" data-id="element-255">
        <div className="bg-[#2C3E50] text-white p-3 rounded-lg flex-shrink-0" data-id="element-256">
          <GiftIcon className="w-6 h-6" data-id="element-257" />
        </div>
        <div data-id="element-258">
          <span className="text-sm font-bold text-[#27AE60] uppercase tracking-wider" data-id="element-259">
            BONO #{number}
          </span>
          <h4 className="text-xl font-bold text-[#2C3E50] mb-2 mt-1" data-id="element-260">
            {title}
          </h4>
          <p className="text-gray-700 mb-4" data-id="element-261">{description}</p>
          <div className="flex items-center gap-2 text-sm" data-id="element-262">
            <span className="text-gray-500" data-id="element-263">Valor:</span>
            <span className="line-through text-gray-400" data-id="element-264">{value}</span>
            <span className="font-bold text-[#27AE60]" data-id="element-265">| GRATIS</span>
          </div>
        </div>
      </div>
    </div>;
}